export default {
  acceptTermsRequired: 'કૃપા કરીને terms and conditions સ્વીકારો',
  accountNumber: 'A/C Number',
  acknowledgedText: 'સ્વીકૃત',
  acknowledgeText: 'સ્વીકારો',
  active: 'સક્રિય',
  activeBookings: 'સક્રિય બુકિંગ',
  activeBucketsText: 'સક્રિય બકેટ',
  activeToday: 'આજે સક્રિય',
  adminRole: 'એડમિન — મેનેજિંગ ડાયરેક્ટર',
  advance: 'એડવાન્સ',
  advancePaid: 'અગ્રિમ ચૂકવ્યું',
  advancePaidLabel: 'એડવાન્સ',
  agreement: 'નિયમો અને કરાર',
  agreeTermsCheckbox: 'મેં બધા નિયમો અને શરતો વાંચી સ્વીકાર્યા',
  alertLog: 'ચેતવણી લોગ',
  alerts: 'ચેતવણીઓ',
  alertText: 'ચેતવણી',
  allAlerts: 'બધી ચેતવણીઓ',
  allLoaded: 'બધું લોડ',
  allMachinesOk: 'બધી મશીનો યોગ્ય રીતે ચાલી રહી છે.',
  allowedText: 'મંજૂર',
  allStats: 'સંપૂર્ણ આંકડા',
  amount: 'રકમ',
  apiHealthTitle: 'API Health',
  apiSloAlertsTitle: 'API SLO Alerts',
  appName: 'Development Express',
  approvals: 'મંજૂરીઓ',
  approveAndDispatch: 'મંજૂર કરી મશીન મોકલો',
  approved: 'મંજૂર',
  assignedOperator: 'સોંપેલ ઓપરેટર',
  attemptsLabel: 'પ્રયાસો',
  attendance: 'હાજરી',
  auditLogs: 'ઑડિટ લોગ',
  available: 'ઉપલબ્ધ',
  availableMachinery: 'ઉપલબ્ધ મશીનરી',
  availableNow: 'હવે ઉપલબ્ધ',
  avgRating: 'સરેરાશ રેટિંગ',
  awaitingClientFeedback: 'ગ્રાહક પ્રતિસાદની રાહ',
  awaitingDispatch: 'ડિસ્પેચની રાહ',
  back: 'પાછા',
  backToLogin: 'લોગઇન પર પાછા',
  bank: 'બેંક',
  bankDetailsTitle: 'બેંક વિગત',
  baseAmount: 'મૂળ રકમ',
  billingWallet: 'વૉલેટ અને બિલિંગ',
  blacklistWarning: '⛔ બ્લેકલિસ્ટ ચેતવણી',
  blockedRateText: 'બ્લોક દર',
  blockedText: 'બ્લોક',
  bookingConfirm: 'બુકિંગની પુષ્ટિ',
  bookingCostCalculator: 'બુકિંગ અને ખર્ચ કેલ્ક્યુલેટર',
  bookingFailedGeneric: 'બુકિંગ નિષ્ફળ. ફરી પ્રયાસ કરો.',
  bookingHistory: 'બુકિંગ ઇતિહાસ',
  bookingReportTitle: 'બુકિંગ રિપોર્ટ',
  bookingScheduleSummary: 'દિવસ અને મહિનાના બુકિંગ શેડ્યૂલ',
  bookingsCount: '{count} બુકિંગ',
  bookingSelectMachineFirst: 'આગળ વધવા ફ્લીટમાંથી મશીન પસંદ કરો.',
  bookingsScheduleHint: 'ગ્રાહકો બુક કરે ત્યારે દૈનિક શેડ્યૂલ અહીં દેખાશે.',
  bookingStepChoose: 'મશીન પસંદ કરો',
  bookingStepConfirm: 'પુષ્ટિ કરી ચૂકવો',
  bookingStepCost: 'ખર્ચ અને તારીખો',
  bookingType: 'બુકિંગ પ્રકાર પસંદ કરો',
  bookingTypeLabel: 'બુકિંગ પ્રકાર',
  bookingTypeText: 'બુકિંગ પ્રકાર',
  bookMachine: 'મશીન બુક કરો',
  bookMachineAction: 'મશીન બુક કરો',
  bookNow: 'હવે બુક કરો',
  burstText: 'BURST',
  busy: 'વ્યસ્ત',
  callNow: 'હવે કૉલ કરો',
  cancel: 'રદ કરો',
  cancelAction: 'રદ કરો',
  cancelBooking: 'બુકિંગ રદ',
  cancelBookingPrompt: 'બુકિંગ રદ કરવી છે?',
  cancelPolicy: 'રદ નીતિ',
  cancelText: 'રદ',
  cancelWarning: 'શું તમે રદ કરવા માંગો છો?',
  changeLanguage: 'ભાષા બદલો',
  changeMachine: 'મશીન બદલો',
  changeMobileNumber: 'મોબાઇલ નંબર બદલો',
  chipAction: 'ક્રિયા',
  chipActor: 'એક્ટર',
  chipEntity: 'entity',
  chipFrom: 'થી',
  chipMeta: 'meta',
  chipRole: 'ભૂમિકા',
  chipTo: 'સુધી',
  clearAll: 'બધું સાફ કરો',
  client: 'ગ્રાહક',
  clientFeedbackLabel: 'ગ્રાહક પ્રતિસાદ',
  clientPortal: 'ગ્રાહક પોર્ટલ',
  clientRatingsTitle: 'ગ્રાહક રેટિંગ અને સૂચનો',
  clientRole: 'ગ્રાહક (કોન્ટ્રાક્ટર)',
  clients: 'ગ્રાહકો',
  commission: 'કમિશન',
  commission15: 'કમિશન 15%',
  commissionPaid: 'કમિશન ચૂકવ્યું',
  commissionRate: 'કુલ બિલિંગનું 15%',
  company: 'કંપની',
  companyDetailsTitle: 'કંપની વિગત',
  completeBookings: 'પૂર્ણ બુકિંગ',
  completedBookings: 'પૂર્ણ બુકિંગ',
  condition: 'સ્થિતિ',
  confirm: 'પુષ્ટિ કરો',
  confirmBooking: 'બુકિંગની પુષ્ટિ',
  confirmBookingAction: 'બુકિંગની પુષ્ટિ કરો',
  confirmCancel: 'રદની પુષ્ટિ કરો',
  confirmPassword: 'પાસવર્ડની પુષ્ટિ',
  confirmRetry: 'ફરી પ્રયાસની પુષ્ટિ કરો',
  contactCompany: 'Development Express સંપર્ક કરો',
  costCalculator: 'ખર્ચ કેલ્ક્યુલેટર',
  crawlerNoRto: 'Crawler (RTO નથી)',
  currentlyDeployed: 'હાલમાં તૈનાત',
  customAmount: 'કસ્ટમ રકમ (ન્યૂનતમ ₹5,000)',
  cycles: "ચક્ર",
  dailyWorkReport: 'દૈનિક કામ રિપોર્ટ',
  dashboard: 'ડેશબોર્ડ',
  date: 'તારીખ',
  dayMachinesLabel: 'મશીનો',
  days: 'દિવસ',
  daysUnit: 'દિવસ',
  directContactBlacklist: 'સીધો સંપર્ક = બ્લેકલિસ્ટ',
  directContactProhibited: 'સીધા સંપર્ક કડક પ્રતિબંધિત',
  directContactProhibitedText: 'સીધો સંપર્ક કડક પ્રતિબંધિત',
  dispatched: 'મોકલાયું',
  dlqMonitor: 'DLQ મોનિટર',
  docChassisPlate: 'Chassis / Serial Plate Photo (RTO RC નથી)',
  docEquipmentPhoto: 'Full Machine Photo (side view)',
  docIdentity: 'PAN Card / Aadhaar',
  docInsurance: 'Insurance Certificate',
  docInsuranceOptional: 'Insurance / Equipment Cover (if available)',
  docMachineInvoice: 'Machine Purchase / Invoice (dealer bill)',
  docPollution: 'Pollution Certificate (PUC)',
  docRcBook: 'RC Book (RTO Registration Certificate)',
  documents: 'દસ્તાવેજ અપલોડ',
  documentUploadTitle: 'દસ્તાવેજ અપલોડ',
  download: 'ડાઉનલોડ',
  drawerMenu: 'મેનુ',
  earnings: 'કમાણી',
  email: 'ઇમેઇલ સહાય',
  emailAddress: 'ઇમેઇલ સરનામું',
  emailAddressLabel: 'ઇમેઇલ સરનામું',
  expandBookingHint: 'પૂર્ણ બુકિંગ, રદ અને ઓપરેટર રેટિંગ માટે નીચે મહિના/દિવસ વિભાગ વિસ્તારો.',
  experience: 'અનુભવ',
  exportCsv: 'CSV એક્સપોર્ટ',
  failedText: 'નિષ્ફળ',
  feedbackAfterDispatch: 'મશીન ડિસ્પેચ પછી ઓપરેટર રેટિંગ ઉપલબ્ધ થશે.',
  feedbackStatusAfterDispatch: 'ડિસ્પેચ પછી',
  feedbackStatusRateNow: 'ઓપરેટર રેટ કરો ↓',
  filterAll: 'બધા',
  filterCredit: 'ક્રેડિટ',
  filterDebit: 'ડેબિટ',
  filterCompleted: 'પૂર્ણ',
  filterCancelled: 'બંધ',
  filterPending: 'બાકી',
  filterDisputed: 'વિવાદિત',
  forgotPasswordChooseMethod: 'પાસવર્ડ રીસેટ માટે ઇમેઇલ લિંક અથવા SMS OTP પસંદ કરો.',
  forgotPasswordEmailDevHint: 'Local dev: API server ટર્મિનલ ખોલીને “Password reset link (development)” URL કૉપી કરો.',
  forgotPasswordEmailHint: 'નોંધાયેલ એડમિન ઇમેઇલ સરનામું દાખલ કરો.',
  forgotPasswordFailed: 'રીસેટ લિંક મોકલી શકાયું નહીં. ફરી પ્રયાસ કરો.',
  forgotPasswordIntro: 'નોંધાયેલ ઇમેઇલ સરનામાં પર સુરક્ષિત રીસેટ લિંક મોકલીશું.',
  forgotPasswordInvalidEmail: 'માન્ય ઇમેઇલ સરનામું દાખલ કરો.',
  forgotPasswordInvalidOtp: 'SMS માંથી 6 અંકનો OTP દાખલ કરો.',
  forgotPasswordInvalidPhone: 'માન્ય 10 અંકનો મોબાઇલ નંબર દાખલ કરો.',
  forgotPasswordLink: 'પાસવર્ડ ભૂલી ગયા?',
  forgotPasswordOtpSentTo: 'OTP મોકલ્યો:',
  forgotPasswordPhoneHint: 'નોંધાયેલ મોબાઇલ નંબર દાખલ કરો. રીસેટ લિંક તમારા એકાઉન્ટના ઇમેઇલ પર જશે.',
  forgotPasswordSending: 'મોકલી રહ્યા છીએ...',
  forgotPasswordSendingOtp: 'OTP મોકલી રહ્યા છીએ...',
  forgotPasswordSendOtp: 'OTP મોકલો',
  forgotPasswordSmsDevHint: 'Productionમાં SMS હજી સેટ નથી — developmentમાં OTP કોડ માટે server logs જુઓ.',
  forgotPasswordSmsFailed: 'OTP મોકલી શકાયો નહીં. ફરી પ્રયાસ કરો.',
  forgotPasswordSmsHint: 'નોંધાયેલ મોબાઇલ નંબર દાખલ કરો. 6 અંકનો OTP SMS દ્વારા મોકલાશે.',
  forgotPasswordSmsSuccess: 'એકાઉન્ટ હોય તો, નોંધાયેલ મોબાઇલ પર OTP મોકલાયો.',
  forgotPasswordSubmit: 'રીસેટ લિંક મોકલો',
  forgotPasswordSuccess: 'એકાઉન્ટ હોય તો, નોંધાયેલ ઇમેઇલ પર રીસેટ સૂચનાઓ મોકલાઈ.',
  forgotPasswordTitle: 'તમારો પાસવર્ડ રીસેટ કરો',
  formLabel: 'ફોર્મ',
  fuel: 'ઇંધણ',
  fuelColon: 'બળતણ:',
  fuelHistoryTitle: 'બળતણ ઇતિહાસ',
  fuelLevel: 'ઇંધણ સ્તર',
  fuelLevelUpdate: 'ઇંધણ સ્તર અપડેટ',
  fuelNotePlaceholder: 'નોંધ: ભર્યું / વપરાયેલ બળતણ...',
  fullName: 'પૂરું નામ',
  goBook: '→ મશીન બુક કરો',
  gpsLiveLabel: '🟢 GPS લાઇવ',
  grandTotal: 'કુલ રકમ',
  grandTotalText: 'કુલ રકમ',
  gross: 'કુલ',
  grossBilling: 'કુલ બિલિંગ',
  gst18: 'GST (18%)',
  gstin: 'GSTIN',
  gstInvoice: 'GST ઇન્વૉઇસ',
  gstInvoices: 'GST ઇન્વૉઇસ',
  hide: 'છુપાવો',
  highTrend: 'HIGH Trend',
  hitsText: 'hits',
  hmrHrs: 'કલા',
  hmrToday: 'આજનું HMR',
  hmrTotal: 'કુલ HMR',
  home: 'હોમ',
  hours: 'કલાક',
  hrsUnit: 'કલાક',
  idle: 'નિષ્ક્રિય',
  ifsc: 'IFSC',
  ignition: 'ઇગ્નિશન',
  importantInfo: 'મશીન માલિકો માટે મહત્વપૂર્ણ માહિતી',
  instantCost: 'ત્વરિત ખર્ચ કેલ્ક્યુલેટર',
  invoiceNotAvailableCancelled: 'ઇન્વૉઇસ ઉપલબ્ધ નથી (રદ)',
  iot: 'IoT & GPS',
  issueReportedSuccess: 'સમસ્યા સફળતાપૂર્વક રિપોર્ટ!',
  issueReportTitle: 'સમસ્યા રિપોર્ટ',
  issues: 'સમસ્યાઓ',
  joinUsAction: 'Join Us — મફત નોંધણી',
  joinUsBanner: 'મશીનરી ભાડે જોઈએ છે?',
  joinUsHint: 'નવા ગ્રાહક? JCB, excavator, crane બુક કરવા મફત નોંધણી.',
  landingCtaApp: 'Development Express શોધો',
  landingFeatBook: 'મિનિટોમાં બુકિંગ',
  landingFeatBookDesc: 'JCB, excavators, cranes — live availability & instant booking.',
  landingFeatPay: 'Wallet-only payments',
  landingFeatPayDesc: 'પારદર્શક બિલિંગ, GST invoices, રોકડની ગડબડ નહીં.',
  landingFeatTrack: 'Live GPS tracking',
  landingFeatTrackDesc: 'ભાડે દરેક કલાકે તમારી મશીન ક્યાં છે તે જાણો.',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'મહારાષ્ટ્ર મશીનરી ભાડું — નવી રીત.',
  landingSocialProof: 'મહારાષ્ટ્રભરના બિલ્ડર, કોન્ટ્રાક્ટર અને ફ્લીટ માલિકો.',
  landingStatMachines: 'મશીનો',
  landingStatRating: 'રેટિંગ',
  landingTrustLine: 'Wallet-only · GST compliant · Secured operations',
  lastRefreshed: 'છેલ્લું રિફ્રેશ',
  live: 'લાઇવ',
  liveBookAvail: 'બુકિંગ પછી લાઇવ ફીડ ઉપલબ્ધ',
  liveCamera: '360° લાઇવ કેમેરા — બુકિંગ પછી',
  liveMachineLocation: 'લાઇવ મશીન સ્થાન',
  liveText: 'લાઇવ',
  liveTracking: 'લાઇવ ટ્રેકિંગ',
  loadedBookings: 'લોડ બુકિંગ',
  loadedDlqItems: 'લોડ DLQ આઇટમ',
  loadedFuelLogs: 'લોડ ઇંધણ લોગ',
  loadedOwnerBookings: '{count} માલિક બુકિંગ લોડ{suffix}',
  loading: 'લોડ થઈ રહ્યું છે...',
  loadingDashboard: 'ડેશબોર્ડ લોડ થઈ રહ્યું છે...',
  loadMoreAlerts: 'વધુ ચેતવણીઓ લોડ કરો',
  loadMoreAttendance: 'વધુ હાજરી લોડ કરો',
  loadMoreBookings: 'વધુ બુકિંગ લોડ કરો',
  loadMoreDlq: 'વધુ DLQ લોડ કરો',
  loadMoreFuelLogs: 'વધુ ઇંધણ લોગ લોડ કરો',
  loadMoreLogs: 'વધુ લોગ લોડ કરો',
  loadMoreMachines: 'વધુ મશીનો લોડ કરો',
  loadMoreTransactions: 'વધુ વ્યવહાર લોડ કરો',
  loadMoreUsers: 'વધુ વપરાશકર્તાઓ લોડ કરો',
  location: 'સ્થાન',
  lockConfirm: '🔒 લૉકની પુષ્ટિ',
  locked: 'લૉક',
  lockMachine: 'મશીન લૉક કરો',
  lockWarning: 'Teltonika GPS દ્વારા મશીન ઇગ્નિશન દૂરથી બંધ થશે.',
  loginAs: 'લોગઇન થઈ રહ્યા છે',
  loginChangeRole: 'ભૂમિકા બદલો',
  loginClientPortalSubtitle: 'નિર્માણ મશીનરી બુક કરવા સાઇન ઇન',
  loginEmailHint: 'એડમિન લોગઇન માટે નોંધાયેલ ઇમેઇલ વાપરો.',
  loginFailedGeneric: 'લોગઇન નિષ્ફળ — કૃપા કરીને ફરી પ્રયાસ કરો',
  loginIAmQuestion: 'હું કોણ…?',
  loginModeOtp: 'OTP લોગઇન',
  loginModePassword: 'પાસવર્ડ',
  loginNewHereRegister: 'નવા છો? નોંધણી',
  loginOtpDevHint: 'Development: SMS ન આવે તો API server log માં OTP જુઓ.',
  loginOtpHint: 'તમારા નોંધાયેલ મોબાઇલ નંબર પર 6 અંકનો OTP મોકલવામાં આવશે.',
  loginOtpSentTo: 'OTP મોકલ્યો:',
  loginOwnerPortalSubtitle: 'ફ્લીટ અને નોંધણી સંચાલન માટે સાઇન ઇન',
  loginPhoneHint: 'ગ્રાહક, માલિક અને ઓપરેટર લોગઇન માટે નોંધાયેલ મોબાઇલ નંબર વાપરો.',
  loginPickRoleHint: 'નોંધાયેલ? ભૂમિકા પસંદ કરો. નવા? નીચે Join Us.',
  loginPortalAdminSubtitle: 'પ્લેટફોર્મ નિયંત્રણ અને મંજૂરી',
  loginPortalAdminTitle: 'એડમિન પોર્ટલ',
  loginPortalClientSubtitle: 'બાંધકામ મશીનરી બુક કરવા સાઇન ઇન',
  loginPortalClientTitle: 'ગ્રાહક પોર્ટલ',
  loginPortalOperatorSubtitle: 'સોંપેલ મશીન અને લોગ માટે સાઇન ઇન',
  loginPortalOperatorTitle: 'ઓપરેટર પોર્ટલ',
  loginPortalOwnerSubtitle: 'ફ્લીટ અને નોંધણી સંચાલન માટે સાઇન ઇન',
  loginPortalOwnerTitle: 'માલિક પોર્ટલ',
  loginRoleAdminDesc: 'પ્લેટફોર્મ નિયંત્રણ, મંજૂરી અને ઓપરેશન',
  loginRoleClientDesc: 'બાંધકામ પ્રોજેક્ટ માટે મશીનરી બુક કરો',
  loginRoleClientShort: 'ગ્રાહક',
  loginRoleOperatorDesc: 'સોંપેલ મશીન અને દૈનિક લોગ',
  loginRoleOwnerDesc: 'ફ્લીટ, કમાણી અને ઉપલબ્ધતા સંચાલન',
  loginRoleOwnerShort: 'માલિક',
  loginSendingOtp: 'OTP મોકલી રહ્યા છીએ...',
  loginSendOtp: 'OTP મોકલો',
  loginSignInShort: 'સાઇન ઇન',
  loginTabOtp: 'OTP',
  loginTabPassword: 'પાસવર્ડ',
  loginVerifyingOtp: 'Verify થઈ રહ્યું છે...',
  loginVerifyOtp: 'Verify & Sign In',
  logout: 'લૉગઆઉટ',
  sessionRevokedAlert: 'તમે બીજા ડિવાઇસ પર લૉગ ઇન છો. કૃપા કરીને ફરીથી લૉગિન કરો.',
  machine: 'મશીન',
  machineDefaultLabel: 'મશીન',
  machineDetails: 'મશીન અને ઓપરેટર વિગતો',
  machineDetailsTitle: 'મશીન વિગતો',
  machineDispatchedAt: 'મશીન મોકલાઈ — {when}',
  machineHours: 'મશીન કલાક',
  machineIdLabel: 'મશીન ID',
  machineInfo: 'મશીન માહિતી',
  machineLabel: 'મશીન',
  machineLog: 'મશીન લોગ',
  machineReg: 'મશીન નોંધણી ફોર્મ',
  machineRegistrationSubmitted: 'મશીન નોંધણી સબમિટ! DE ટીમ 24 કલાકમાં ચકાસશે.',
  machineRegistrationTitle: 'મશીન નોંધણી',
  machines: 'મશીનો',
  machineStatus: 'મશીન સ્થિતિ',
  machineStatusTitle: 'મશીન સ્થિતિ',
  marketingBackHome: 'વેબસાઇટ પર પાછા',
  marketingBadge: 'LIVE OPERATIONS · KARAD, SATARA',
  marketingBuiltFor: 'ચોકસાઈ, અનુપાલન અને ઝડપ જોઈતી ભારતીય બાંધકામ ટીમો માટે.',
  marketingCtaBook: 'મશીન બુક કરો',
  marketingCtaLogin: 'Development Express ખોલો — Login',
  marketingCtaWhatsApp: 'WhatsApp કરો',
  marketingFooterRights: '2026 Development Express · Karad, Satara · All rights reserved',
  marketingHeadline: 'મહારાષ્ટ્રનું leading machinery rental platform',
  marketingLead: 'Real-time GPS tracking, digital wallet payments, and automated operations for construction machinery. Serving Maharashtra since 2011.',
  marketingNavContact: 'સંપર્ક',
  marketingNavLogin: 'પ્લેટફોર્મ લોગઇન →',
  marketingNavServices: 'સેવાઓ',
  marketingNavTech: 'Technology',
  marketingServicesTitle: 'અમે શું આપીએ છીએ',
  marketingStatDigital: 'Digital payments',
  marketingStatFleet: 'Live machines',
  marketingStatYears: 'વર્ષનો અનુભવ',
  marketingSvcOps: 'Full operations stack',
  marketingSvcOpsSub: 'Owner, operator, and client — one platform.',
  marketingSvcPay: 'Wallet-only settlements',
  marketingSvcPaySub: 'GST-ready invoicing — no cash on site.',
  marketingSvcTrack: 'GPS & live status',
  marketingSvcTrackSub: 'Teltonika-linked fleet visibility for every booking.',
  marketingTechLead: 'Development Express ties bookings, compliance, and field telemetry into a single hardened workflow — from first enquiry to final invoice.',
  md: 'MD',
  mediumTrend: 'MEDIUM Trend',
  minAdvanceRequired: 'ન્યૂનતમ એડવાન્સ જરૂરી',
  minimumAdvance: 'ન્યૂનતમ એડવાન્સ જરૂરી',
  minimumRecharge: 'UPI/કાર્ડ માટે ન્યૂનતમ ₹1',
  mobileNumber: 'મોબાઇલ નંબર',
  monthMachineSummary: 'આ મહિનાની મશીનો',
  months: 'મહિના',
  monthTotalLabel: 'મહિનાનું કુલ',
  moreAvailable: 'વધુ ઉપલબ્ધ',
  moUnit: 'મહિના',
  myBookings: 'મારી બુકિંગ',
  myClientRating: 'મારું ગ્રાહક રેટિંગ',
  myMachines: 'મારી મશીનો',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'નેટ કમાણી (મહિનો)',
  netPaid: 'નેટ ચૂકવણી',
  netPayable: 'નેટ ચૂકવવાનું',
  netReceived: 'નેટ મળેલું',
  netReceivedCaps: 'નેટ મળેલું',
  neverText: 'ક્યારેય નહીં',
  newBooking: 'નવી બુકિંગ',
  newClientRegister: 'નવા ગ્રાહક? અહીં નોંધણી કરો',
  newClientRegistration: 'નવા ગ્રાહક નોંધણી',
  newPassword: 'નવો પાસવર્ડ',
  nextText: 'આગળ',
  noAlerts: 'કોઈ ચેતવણી નથી!',
  noAlertsNow: 'હમણાં કોઈ અલર્ટ નથી.',
  noBankRefund: '❌ બેંક રિફંડ નહીં — માત્ર વૉલેટ ક્રેડિટ',
  noBookings: 'સક્રિય બુકિંગ નથી',
  noBookingsAccount: 'આ ખાતા માટે હજી બુકિંગ નથી.',
  noBookingsYet: 'હજી બુકિંગ નથી',
  noClientFeedbackYet: 'હજી ગ્રાહક રેટિંગ નથી. ડિસ્પેચ પછી ગ્રાહક પ્રતિસાદ અહીં દેખાશે.',
  noDlqItems: 'DLQ આઇટમ નથી',
  noFileSelected: 'ફાઇલ પસંદ નથી',
  noMachinesDashboard: 'હજી મશીનો નથી. ફ્લીટ ઉમેરવા મશીન નોંધણી વાપરો.',
  noMachinesTrack: 'ટ્રેક કરવા મશીનો નથી',
  noMachinesTrackHint: 'GPS ટ્રેકિંગ માટે મશીન નોંધણી કરો.',
  noMachinesYet: 'હજી મશીનો નોંધાયા નથી',
  noMoreAuditLogs: 'વર્તમાન ફિલ્ટર માટે વધુ ઑડિટ લોગ નથી.',
  noRecentApiSloBreach: 'તાજેતરમાં API SLO breach સંકેત નથી.',
  noRecentFailedLogins: 'તાજેતરમાં નિષ્ફળ લોગઇન પ્રયાસો નથી.',
  noRefund: 'રિફંડ નહીં નીતિ',
  normalText: 'સામાન્ય',
  noSecuritySignalsFound: 'સુરક્ષા સંકેત મળ્યા નહીં.',
  noTransactionsFilter: 'પસંદ ફિલ્ટર માટે વ્યવહાર નથી.',
  off: 'OFF',
  officeLabel: 'ઓફિસ',
  on: 'ON',
  operator: 'ઓપરેટર',
  operatorFeedbackColumn: 'ઓપરેટર પ્રતિસાદ',
  operatorFeedbackSaved: 'આભાર! તમારો પ્રતિસાદ સાચવ્યો.',
  operatorFeedbackSubmitted: 'તમારો પ્રતિસાદ',
  operatorFeedbackTitle: 'ઓપરેટર પ્રતિસાદ',
  operatorPortal: 'ઓપરેટર પોર્ટલ',
  operatorRole: 'ઓપરેટર',
  operators: 'ઓપરેટર',
  operatorSatisfactionQuestion: 'શું તમે ઓપરેટરથી સંતુષ્ટ છો?',
  operatorSuggestionPlaceholder: 'સૂચન અથવા પ્રતિસાદ (ઐચ્છિક)',
  optionalLabel: '(ઐચ્છિક)',
  otpCode: 'OTP કોડ',
  overview: 'ઝલક',
  ownerBookingsAllLoaded: ' (બધું લોડ)',
  ownerBookingsMoreAvailable: ' (વધુ ઉપલબ્ધ)',
  ownerInfo: 'માલિક માહિતી',
  ownerPortal: 'માલિક પોર્ટલ',
  ownerRole: 'મશીન માલિક',
  owners: 'માલિકો',
  password: 'પાસવર્ડ',
  passwordsMustMatch: 'પાસવર્ડ અને પુષ્ટિ એકસર ખાતા હોવા જોઈએ.',
  pastIssuesTitle: 'ભૂતકાળની સમસ્યાઓ',
  paymentBreakdownTitle: 'ચુકવણી વિગત — April 2026',
  paymentCycle: 'ચુકવણી ચક્ર',
  paymentFailed: 'ચુકવણી નિષ્ફળ! કૃપા કરીને ફરી પ્રયાસ કરો.',
  paymentHistory: 'ચુકવણી ઇતિહાસ',
  paymentHistoryTitle: 'ચુકવણી ઇતિહાસ',
  paymentMethods: 'ચુકવણી પદ્ધતિઓ',
  paymentMode: 'ચુકવણી પદ્ધતિ',
  paymentSuccess: 'ચુકવણી સફળ!',
  payNow: 'હવે ચૂકવો',
  payNowText: 'હવે ચૂકવો',
  pdfInvoiceFailed: 'ઇન્વૉઇસ PDF બનાવી શકાયું નહીં. ફરી પ્રયાસ કરો.',
  pdfReportFailed: 'રિપોર્ટ PDF બનાવી શકાયું નહીં. ફરી પ્રયાસ કરો.',
  pdiCompleted: '✅ PDI / Safety inspection પૂર્ણ',
  pdiCrawlerHint: 'Crawler plant: pollution (PUC) જરૂરી નથી — મશીન RTO road-registered નથી.',
  pdiInfo: 'PDI તપાસ',
  pdiInsuranceApplicable: '✅ Insurance / cover (if applicable)',
  pdiInsuranceValid: '✅ Insurance valid & up to date',
  pdiPollutionValid: '✅ Pollution certificate (PUC) valid',
  pdiTitle: 'Pre-Delivery Inspection (PDI)',
  penaltyDeduct: 'રદ દંડ (1 કલાક)',
  pending: 'બાકી',
  pendingApproval: 'મંજૂરી બાકી',
  pendingCount: '{count} બાકી',
  pendingDispatch: 'ડિસ્પેચ બાકી',
  perDay: 'દિવસે',
  perHour: 'કલાકે',
  perMonth: 'મહિને',
  perWeek: 'અઠવાડિયે',
  phone: 'ફોન',
  platform: 'નિર્માણ સંચાલન પ્લેટફોર્મ',
  platformAgreement: 'પ્લેટફોર્મ કરાર',
  policyLabel: 'નીતિ',
  policyTopicBooking: 'બુકિંગ',
  policyTopicCancellation: 'રદ',
  policyTopicContact: 'સંપર્ક',
  policyTopicGst: 'GST',
  policyTopicHours: 'સપોર્ટ સમય',
  portalBackLink: 'પોર્ટલ',
  portalClient: 'ગ્રાહક',
  portalClientSub: 'મશીનરી બુક કરો',
  portalNewClientRegister: 'નવા ગ્રાહક? નોંધણી',
  portalNewOwnerRegister: 'નવા માલિક? નોંધણી',
  portalOwner: 'માલિક',
  portalOwnerSub: 'ફ્લીટ સંચાલન',
  portalStaffAdmin: 'એડમિન',
  portalStaffOperator: 'ઓપરેટર',
  portalWelcome: 'સ્વાગત છે',
  portalWelcomeHint: 'આગળ વધવા તમારું પોર્ટલ પસંદ કરો',
  quantityLabel: 'જથો',
  quickIssueReport: 'ઝડપી સમસ્યા રિપોર્ટ',
  quickRechargeUpi: 'UPI દ્વારા ઝડપી રિચાર્જ',
  quickSelect: 'ઝડપી પસંદગી:',
  rateCard: 'રેટ કાર્ડ (ઓપરેટર સહિત)',
  rateLimitTelemetryTitle: 'Rate Limit Telemetry',
  rateOperatorWork: 'ઓપરેટર કામ રેટ કરો (1–5 stars)',
  rating: 'રેટિંગ',
  receiptId: 'રસીદ ID',
  recentAlerts: 'તાજેતરની ચેતવણીઓ',
  recentFailedLoginsTitle: 'તાજેતરના નિષ્ફળ લોગઇન',
  recentLabel: 'તાજેતરનું',
  recharge: 'રિચાર્જ',
  rechargeFirst: '⚡ પહેલા વૉલેટ રિચાર્જ કરો',
  rechargeWallet: '+ વૉલેટ રિચાર્જ',
  ref: 'સંદર્ભ નંબર',
  refreshingText: 'રિફ્રેશ થઈ રહ્યું છે...',
  refreshText: 'રિફ્રેશ',
  regCapacitySpecs: 'ક્ષમતા / વિગતો',
  regDocCrawlerHint: 'Crawler (excavator): chassis plate, machine purchase invoice, machine photo અને ID જરૂરી. Insurance optional.',
  regDocWheeledHint: 'Wheeled: RC (RTO), insurance, PUC અને ID જરૂરી (દરેક 5MB).',
  regEquipmentCategory: 'ઉપકરણ વર્ગ *',
  regFailed: 'નોંધણી નિષ્ફળ. કૃપા કરીને ફરી પ્રયાસ કરો.',
  regFileSizeError: 'દરેક document 5MB અથવા ઓછું હોવું જોઈએ',
  regFileTypeError: 'માત્ર PDF, JPG, PNG અથવા WEBP ફાઇલો મંજૂર',
  regFleetIdOptional: 'ફ્લીટ / chassis ID (ઐચ્છિક)',
  register: 'મશીન નોંધણી',
  registerAction: 'નોંધણી કરો',
  registering: 'નોંધણી થઈ રહી છે...',
  registerMachine: 'મશીન નોંધણી',
  registrationPending: 'એડમિન 24 કલાકમાં તમારું એકાઉન્ટ સક્રિય કરશે.',
  registrationSuccess: 'નોંધણી સફળ!',
  regMachineCategory: 'મશીન વર્ગ *',
  regMachineInfoTitle: 'મશીન માહિતી',
  regMachineIntro: 'નિર્માણ heavy equipment માત્ર — ટ્રક/ટ્રાન્સપોર્ટ નહીં. Wheeled plant (ઉદા. JCB 3DX) માટે RTO; crawler plant (Poclain, dozer) સાઇટ-માત્ર — RTO passing નહીં.',
  regMachineNameModel: 'મશીન નામ / મોડેલ',
  regMobilityTracked: 'Crawler',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer, crawler crane — સાઇટ plant, RTO passing નહીં',
  regMobilityWheeled: 'Wheeled',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) સાથે નિર્માણ plant',
  machineFinancialSection: 'મશીન ખરીદી વિગતો (વૈકલ્પિક)',
  machineOwnershipType: 'માલિકી પ્રકાર',
  machineOwnershipNew: 'નવી મશીન',
  machineOwnershipUsed: 'મૂળ માલિક',
  machineOwnershipSecondHand: 'પૂર્વ-માલિકી',
  machinePurchasePrice: 'ખરીદી કિંમત (₹)',
  machinePurchasePriceHint: 'આ મશીન માટે તમે ચૂકવેલી રકમ',
  machinePurchaseDate: 'ખરીદી તારીખ',
  machineYearOfManufacture: 'ઉત્પાદન વર્ષ',
  machineLoanSection: 'આ મશીન પર મારું loan છે',
  machineLoanAmount: 'Loan રકમ (₹)',
  machineLoanEmi: 'માસિક EMI (₹)',
  machineLoanTenure: 'Loan અવધિ (મહિના)',
  machineLoanStartDate: 'Loan શરૂ તારીખ',
  machineFuelConsumption: 'ઇંધન વપરાશ (L/hr)',
  machineMonthlyOperatingExpenses: 'માસિક પરિચાલન ખર્ચ',
  machineOperatorMonthlySalary: 'ઓપરેટર માસિક પગાર',
  machineServiceMonthly: 'સર્વિસ / જાળવણી (માસિક)',
  machineBreakdownMonthly: 'બ્રેકડાઉન / રિપેર (માસિક સરેરાશ)',
  machineMaterialsMonthly: 'સામગ્રી / ઉપભોગ્ય (માસિક)',
  recoveryPlan: 'રિકવરી પ્લાન',
  recoveryOnTrack: 'યોગ્ય માર્ગ પર',
  recoveryNeedsAttention: 'ધ્યાન જરૂરી',
  recoveryActionRequired: 'કાર્યવાહી જરૂરી',
  recoveryAddPrice: 'રિકવરી પ્લાન જોવા ખરીદી કિંમત ઉમેરો',
  recoveryProgress: 'રોકાણ પુનઃપ્રાપ્તિ',
  recoveryDailyNet: 'દૈનિક ચોખ્ખી આવક',
  recoveryDays: 'વસૂલી સમયગાળો',
  recoveryProjectedDate: 'અંદાજિત વસૂલી તારીખ',
  recoveryRoi: 'વાર્ષિક વળતર',
  recoveryCurrentValue: 'વર્તમાન મશીન મૂલ્ય',
  editFinancialDetails: 'નાણાકીય વિગતો સંપાદિત કરો',
  financialDetailsSaved: 'નાણાકીય વિગતો સાચવી',
  recoveryBackfillNudge: 'રિકવરી ટ્રેકિંગ અનલૉક કરવા {{count}} મશીન(ો)માં ખરીદી વિગતો ઉમેરો',
  dieselPriceTitle: 'ડીઝલ ભાવ',
  dieselPriceUpdate: 'ડીઝલ ભાવ અપડેટ કરો',
  dieselPriceLatest: 'તાજેતરનો ભાવ',
  dieselPriceNoRecord: 'ડીઝલ ભાવ નોંધાયેલ નથી',
  dieselPricePerLitre: 'લિટર ભાવ (₹)',
  dieselQuantity: 'ભરેલી માત્રા (લિટર)',
  dieselTaluka: 'શહેર / વિસ્તાર',
  bookingAttachment: 'અટેચમેન્ટ પસંદ કરો',
  bookingAttachmentNone: 'કોઈ ચોક્કસ અટેચમેન્ટ નહીં',
  bookingWorkDescription: 'કામનું વર્ણન',
  bookingWorkDescriptionPlaceholder: 'દા.ત. પાયાનું ખોદકામ, ટ્રેન્ચિંગ, પાઇપલાઇન કામ',
  bookingAttachmentLabel: 'અટેચમેન્ટ',
  bookingSiteLabel: 'સાઇટ',
  bookingWorkLabel: 'કામ',
  termsAccept: "હું નિયમો અને શરતો સાથે સંમત છું",
  termsRequired: "નોંધણી માટે નિયમો અને શરતો સ્વીકારવા જરૂરી છે",
  termsLink: "નિયમો અને શરતો",
  clientBlacklisted: "બ્લેકલિસ્ટ",
  clientBlacklistReason: "બ્લેકલિસ્ટનું કારણ",
  clientBlacklistConfirm: "આ ક્લાયન્ટને બ્લેકલિસ્ટ કરવો?",
  clientUnblacklist: "બ્લેકલિસ્ટમાંથી કાઢો",
  blacklistedClients: "બ્લેકલિસ્ટ ક્લાયન્ટ્સ",
  blacklistedClientsEmpty: "કોઈ બ્લેકલિસ્ટ ક્લાયન્ટ નથી",
  managerAccessRestricted: "ફાઇનાન્સ ઍક્સેસ પ્રતિબંધિત. ઓમ ચવ્હાણનો સંપર્ક કરો.",
  managerSection: "મેનેજર્સ",
  managerAdd: "મેનેજર ઉમેરો",
  managerName: "મેનેજરનું નામ",
  managerEmail: "મેનેજર ઈમેઈલ",
  managerPassword: "કામચલાઉ પાસવર્ડ",
  managerCreated: "મેનેજર એકાઉન્ટ બન્યું",
  managerCredentialsTitle: "મેનેજર લૉગિન વિગતો",
  managerCredentialsSubtitle: "આ વિગતો હમણાં સાચવો — પાસવર્ડ પછીથી પાછો મળશે નહીં",
  managerCredentialsSaved: "મેં વિગતો સાચવી લીધી છે",
  managerLoginUrl: "લૉગિન URL",
  managerActivity: "મેનેજર પ્રવૃત્તિ",
  managerActivityEmpty: "હજુ સુધી કોઈ પ્રવૃત્તિ નોંધાઈ નથી",
  managerActivityViewAll: "બધી પ્રવૃત્તિ જુઓ",
  onboardingTitle: "શરૂ કરો",
  onboardingAccountApproved: "એકાઉન્ટ મંજૂર",
  onboardingKycComplete: "KYC ચકાસણી પૂર્ણ",
  onboardingKycPending: "KYC ચકાસણી પૂર્ણ કરો",
  onboardingKycRejected: "KYC નકારાયું — ફરી સબમિટ કરો",
  onboardingWalletFunded: "વૉલેટમાં રકમ છે",
  onboardingWalletEmpty: "બુકિંગ માટે વૉલેટમાં રકમ ઉમેરો",
  pushEnablePrompt: "ત્વરિત અપડેટ માટે પુશ સૂચનાઓ ચાલુ કરો",
  downloadDisputeStatement: "વિવાદ નિવેદન ડાઉનલોડ કરો",
  downloadInvoice: "ઇનવૉઇસ ડાઉનલોડ કરો",
  bookAgain: "ફરીથી બુક કરો",
  machineNoLongerAvailable: "મશીન હવે ઉપલબ્ધ નથી",
  downloadHistoryPdf: "ઇતિહાસ PDF ડાઉનલોડ કરો",
  onboardingFirstBooking: "તમારી પહેલી બુકિંગ કરો",
  onboardingAllDone: "તમે તૈયાર છો!",
  onboardingTrackerTitle: "ઑનબોર્ડિંગ પ્રગતિ",
  onboardingTrackerTarget: "ઑનબોર્ડિંગ લક્ષ્ય: 48 કલાક",
  onboardingTrackerInProgress: "પ્રગતિમાં",
  onboardingTrackerActionRequired: "કાર્યવાહી જરૂરી",
  onboardingTrackerComplete: "પૂર્ણ",
  onboardingTrackerPending: "બાકી",
  onboardingTrackerPhase1: "નોંધણી",
  onboardingTrackerPhase2: "KYC ચકાસણી",
  onboardingTrackerPhase3: "મશીન નોંધણી",
  onboardingTrackerPhase4: "પહેલી બુકિંગ તૈયાર",
  onboardingTrackerHelper1: "મશીન નોંધણી ખોલવા આધાર + સેલ્ફી અપલોડ કરો",
  onboardingTrackerHelper2: "KYC સમીક્ષામાં — સામાન્ય રીતે 24 કલાકમાં",
  onboardingTrackerHelper3: "KYC નકારાયું — દસ્તાવેજો ફરી સબમિટ કરો",
  onboardingTrackerHelper4: "KYC મંજૂર — તમારું પહેલું મશીન ઉમેરો",
  onboardingTrackerHelper5: "મશીન એડમિન સમીક્ષામાં",
  onboardingTrackerHelper6: "મશીન લાઇવ — પહેલી બુકિંગની રાહ",
  onboardingTrackerPhaseLabel: "તબક્કો",
  alertsAndNotifications: 'ચેતવણીઓ અને સૂચનાઓ',
  dieselFuelCostPerHour: 'કલાક દીઠ ઇંધણ ખર્ચ',
  dieselPercentOfRate: 'તમારા કલાક દરનો',
  dieselPriceSaved: 'ડીઝલ ભાવ સાચવ્યો',
  dieselRateSuggestion: 'દર સૂચન',
  dieselRateIncrease: 'ડીઝલ વધ્યું — દર વધારવા પર વિચાર કરો',
  dieselRateDecrease: 'ડીઝલ ઘટ્યું — બુકિંગ માટે દર ઘટાડો',
  dieselSuggestedRate: 'સૂચવેલો દર',
  dieselHistory: 'કીમત ઇતિહાસ',
  dieselNoHistory: 'હજુ સુધી ડીઝલ કીમત ઇતિહાસ નથી',
  dieselColDate: 'તારીખ',
  dieselColPrice: 'કીમત/લિટર',
  dieselColQty: 'માત્રા',
  dieselColSource: 'સ્રોત',
  dieselUploadReceipt: 'રસીદ અપલોડ',
  dieselExtractSuccess: 'રસીદમાંથી કાઢ્યું',
  dieselExtractFailed: 'કાઢી શકાયું નહીં — કૃપા કરીને મેન્યુઅલ દાખલ કરો',
  applyRateSuggestion: '₹{{rate}}/કલાક લાગુ કરો',
  rateSuggestionApplied: 'દર સફળતાપૂર્વક અપડેટ થઈ',
  marketPosition: 'માર્કેટ સ્થિતિ',
  marketBelowMarket: 'માર્કેટ કરતાં ઓછી',
  marketCompetitive: 'સ્પર્ધાત્મક',
  marketAboveMarket: 'માર્કેટ કરતાં વધુ',
  marketNoData: 'તમારા વિસ્તાર માટે હજુ માર્કેટ ડેટા નથી',
  marketSubmitRate: 'માર્કેટ દર સબમિટ કરો',
  marketCity: 'શહેર / વિસ્તાર',
  marketMinRate: 'તમારા વિસ્તારમાં લઘુત્તમ દર (₹/કલાક)',
  marketMaxRate: 'તમારા વિસ્તારમાં મહત્તમ દર (₹/કલાક)',
  marketRateSubmitted: 'માર્કેટ દર સબમિટ થઈ — આભાર!',
  marketDataPoints: '{{count}} સબમિશન(ઓ) પર આધારિત',
  marketRange: '{{city}} માં માર્કેટ',
  marketSourceLocal: '{{city}} વિસ્તારના ભાવ પર આધારિત',
  marketSourcePlatform: 'પ્લેટફોર્મ-વ્યાપી ભાવ પર આધારિત',
  regPremiumOnboarding: 'Premium onboarding',
  regRtoNumber: 'RTO નોંધણી નંબર *',
  regSelectType: 'પ્રકાર પસંદ કરો…',
  regSubmitBtn: '✅ નોંધણી સબમિટ કરો',
  regTagNoRto: 'RTO નથી',
  regTagRto: 'RTO',
  regYearManufacture: 'ઉત્પાદન વર્ષ *',
  remoteLockAlert: 'Teltonika GPS device આ મશીન પર સ્થાપિત થયા પછી remote lock enable થશે. DE support સંપર્ક કરો.',
  remoteLockMachine: '🔒 રિમોટ લૉક મશીન',
  replaceFile: 'બદલો',
  reports: 'રિપોર્ટ',
  reportText: 'રિપોર્ટ',
  resetMethodEmail: 'ઇમેઇલ લિંક',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'પાસવર્ડ રીસેટ થયો નહીં. નવી લિંક માંગો.',
  resetPasswordIntro: 'ઓછામાં ઓછા 8 અક્ષરનો મજબૂત પાસવર્ડ પસંદ કરો.',
  resetPasswordMinLength: 'પાસવર્ડ ઓછામાં ઓછા 8 અક્ષરનો હોવો જોઈએ.',
  resetPasswordMissingToken: 'રીસેટ લિંક ગુમ અથવા અમાન્ય. લોગઇનથી Forgot password વાપરો.',
  resetPasswordSubmit: 'પાસવર્ડ અપડેટ કરો',
  resetPasswordSuccess: 'પાસવર્ડ અપડેટ થયો. લોગઇન પર પાછા લઈ જઈ રહ્યા છીએ...',
  resetPasswordTitle: 'નવો પાસવર્ડ સેટ કરો',
  resetPasswordUpdating: 'અપડેટ થઈ રહ્યું છે...',
  resetText: 'રીસેટ',
  retryDlqItemTitle: 'DLQ આઇટમ ફરી પ્રયાસ',
  retryFailedForDlq: 'DLQ આઇટમ માટે ફરી પ્રયાસ નિષ્ફળ',
  retryReasonAuditPlaceholder: 'ફરી પ્રયાસનું કારણ (ઑડિટ માટે)',
  retryText: 'ફરી પ્રયાસ કરો',
  revenue: 'આવક',
  running: 'ચાલી રહી છે',
  satisfiedNo: 'સંતુષ્ટ નથી',
  satisfiedYes: 'હા, સંતુષ્ટ',
  save: 'સાચવો',
  scanToPay: 'ચૂકવણી માટે સ્કેન કરો',
  scheduleColFeedback: 'પ્રતિસાદ',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'કુલ',
  scheduleColType: 'પ્રકાર',
  securitySignalsTitle: 'સુરક્ષા સંકેત',
  selectBook: 'આ મશીન બુક કરો →',
  selectCalc: '📋 પસંદ કરો અને ખર્ચ જુઓ →',
  selectedMachineText: 'પસંદ કરેલી મશીન',
  selectFile: 'ફાઇલ પસંદ કરો',
  selectMachineFirst: 'પહેલા મશીન પસંદ કરો',
  selectQty: 'જથ્થો પસંદ કરો',
  selectRole: 'ભૂમિકા પસંદ કરો',
  send: 'મોકલો',
  sendEmail: 'ઇમેઇલ મોકલો',
  sendWhatsapp: 'WhatsApp પર મોકલો',
  settlements: 'નિપટારા',
  show: 'બતાવો',
  signIn: 'સાઇન ઇન કરો',
  signingIn: 'લોગઇન થઈ રહ્યું છે...',
  signupCompanyName: 'કંપનીનું નામ',
  signupContactName: 'સંપર્ક નામ',
  signupCreatePassword: 'પાસવર્ડ બનાવો',
  signupReenterPassword: 'પાસવર્ડ ફરી દાખલ કરો',
  signupSectionCompany: 'કંપની',
  signupSectionContact: 'તમારી વિગતો',
  signupSectionSecurity: 'સુરક્ષા',
  sinceExcellence: '2011 થી · 15 વર્ષ શ્રેષ્ઠતા',
  sinceLabel: 'થી',
  sloBreachRisk: 'SLO BREACH RISK',
  sloHealthy: 'SLO HEALTHY',
  speed: 'ઝડપ',
  staleText: 'જૂનું',
  status: 'સ્થિતિ',
  statusCancelled: 'રદ',
  bookingClosed: 'બંધ',
  sectionNew: 'નવું',
  sectionAccepted: 'સ્વીકૃત',
  sectionActive: 'સક્રિય',
  sectionDispatched: 'ડિસ્પેચ',
  sectionCompleting: 'પૂર્ણ થઈ રહ્યું',
  sectionDisputed: 'વિવાદ',
  sectionCompleted: 'પૂર્ણ',
  sectionClosed: 'બંધ',
  statusCompleted: 'પૂર્ણ',
  stopped: 'બંધ',
  submit: 'સબમિટ',
  submitOperatorFeedback: 'પ્રતિસાદ સબમિટ કરો',
  submittedRegistrations: 'સબમિટ નોંધણી',
  support: 'સહાય',
  supportPolicyBooking: 'ફક્ત વૉલેટ અગ્રિમ. સાઇટ પર રોકડ નહીં.',
  supportPolicyCancellation: '1 કલાક દંડ; બાકી વૉલેટમાં.',
  supportPolicyContact: 'ફક્ત DE Support — સીધો ઓપરેટર સંપર્ક નિષેધ.',
  supportPolicyGst: 'બધા ઇન્વૉઇસ પર 18% GST; Reports ટેબમાંથી.',
  supportPolicyHours: 'સોમ–શનિ, 9–7 IST',
  tableAtt: 'Att',
  tableChange: 'ફેરફાર',
  tableDay: 'દિવસ',
  tableEnd: 'અંત',
  tableHrs: 'કલા',
  tableId: 'ID',
  tableIn: 'In',
  tableLevel: 'સ્તર',
  tableMonth: 'મહિનો',
  tableNote: 'નોંધ',
  tableOut: 'Out',
  tableStart: 'શરૂઆત',
  tagline: 'ઇન્ફ્રાસ્ટ્રક્ચરનું સોનાનું ધોરણ',
  tax: 'કર',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express કમિશન: કુલ બિલિંગનું 15%',
  termFuel: 'મશીનમાં હંમેશા 40%+ ઇંધણ હોવું જોઈએ',
  termGps: 'GPS device (Teltonika) ફરજિયાત — DE દ્વારા સ્થાપિત',
  termGstTcs: 'GST TCS: GST regulations પ્રમાણે 1%',
  termNoDirectContact: 'સીધો ગ્રાહક સંપર્ક = ત્વરિત contract termination',
  termPaymentDays: 'ગ્રાહક settlement પછી 3 કાર્ય દિવસમાં ચુકવણી',
  termTds: 'TDS deduction: Income Tax Act પ્રમાણે 2%',
  threeWorkingDays: '3 કાર્ય દિવસ',
  timeLabel: 'સમય',
  todayText: 'આજે',
  topSourceIp: 'ટોપ સોર્સ IP',
  total: 'કુલ',
  totalAdvanceLabel: 'એડવાન્સ ચૂકવ્યું',
  totalBookingsText: 'કુલ બુકિંગ',
  totalMachines: 'કુલ મશીનો',
  totalSpent: 'કુલ ખર્ચ',
  tracking: 'GPS ટ્રેકિંગ',
  transactionHistoryTitle: 'વ્યવહાર ઇતિહાસ',
  transactions: 'વ્યવહાર ઇતિહાસ',
  trustStatCompliant: 'અનુપાલન',
  trustStatMachines: 'મશીન',
  trustStatRating: 'રેટિંગ',
  txnDescription: 'વર્ણન',
  type: 'પ્રકાર',
  understood: '✅ સમજાયું — પ્લેટફોર્મ વાપરીશ',
  understoodAction: 'સમજાયું',
  unknownText: 'અજાણ્યું',
  updateFuel: 'ઇંધણ અપડેટ',
  updateText: 'અપડેટ',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'અપલોડ',
  valEmail: 'માન્ય ઇમેઇલ જરૂરી',
  valMachineName: 'મશીન નામ / model જરૂરી',
  valMachineType: 'કૃપા કરીને equipment category પસંદ કરો',
  valMobility: 'કૃપા કરીને wheeled અથવા crawler equipment પ્રકાર પસંદ કરો',
  valOwnerName: 'માલિકનું નામ જરૂરી',
  valPdiChecks: 'કૃપા કરીને બધી required checks confirm કરો',
  valPdiRequired: 'PDI confirmation જરૂરી',
  valPhone: 'માન્ય ફોન નંબર જરૂરી',
  valRto: 'Wheeled machines માટે RTO registration number જરૂરી',
  valUploadMissing: 'કૃપા કરીને upload કરો: {docs}',
  valYear: 'માન્ય year (YYYY) જરૂરી',
  viewMachines: '→ મશીનો જુઓ',
  wallet: 'વૉલેટ',
  walletBalance: 'વૉલેટ બેલેન્સ',
  walletCredit: 'વૉલેટ ક્રેડિટ',
  walletDebit: 'વૉલેટ ડેબિટ',
  walletDeduct: 'એડવાન્સ વૉલેટમાંથી કપાશે · રોકડ નહીં · GST આપમેળે બને છે',
  walletInsufficient: '❌ પૂરતું નથી',
  walletLowRecharge: 'વૉલેટ બેલેન્સ ઓછું — આગલી બુકિંગ પહેલાં રિચાર્જ',
  walletOnly: 'વૉલેટ માત્ર · રોકડ સ્વીકારાતી નથી',
  walletOnlyPolicyDesc: 'બધા વ્યવહાર માત્ર વૉલેટ દ્વારા. રોકડ સ્વીકારાતી નથી.',
  walletOnlyPolicyTitle: 'વૉલેટ-માત્ર નીતિ',
  walletRechargeTitle: 'વૉલેટ રિચાર્જ',
  walletSufficient: '✅ આગળ વધો',
  weeks: 'અઠવાડિયા',
  whatsapp: 'WhatsApp',
  wksUnit: 'અઠવાડિયા',
  year: 'વર્ષ',
  yearsExperience: '{n} વર્ષ',
  yourMessage: 'તમારો પ્રશ્ન અથવા સમસ્યા લખો...',
  // --- Recent feature strings ---
  retryLabel: 'ફરી પ્રયાસ કરો',
  payrollPreview: 'પગાર પૂર્વાવલોકન',
  payrollRun: 'પગાર ચલાવો',
  payrollAlreadyRun: 'આ મહિને માટે પગાર પહેલેથી ચલાવેલો છે',
  payrollGross: 'કુલ દેय',
  payrollNet: 'ચોખ્ખું દેय',
  payrollAdvanceDeducted: 'એડવાન્સ કપાત',
  payrollRunSuccess: 'પગાર સફળતાપૂર્વક ચલાવ્યો',
  payrollNoAmount: 'આ મહિને માટે દેय રકમ નથી',
  payrollMonth: 'પગાર મહિનો',
  exportPayrollCsv: 'પગાર CSV એક્સપોર્ટ',
  payrollExportMonth: 'પગાર એક્સપોર્ટ મહિનો',
  payrollDailyRate: 'દૈનિક દર',
  payrollHistory: 'પગાર ઇતિહાસ',
  payrollNoHistory: 'હજી સુધી કોઈ પગાર ચાલ્યો નથી',
  payrollColMonth: 'મહિનો',
  payrollColGross: 'કુલ',
  payrollColDeduction: 'અગ્રિમ કપાત',
  payrollColNet: 'નેટ પગાર',
  payrollColDate: 'તારીખ',
  downloadPayslip: 'પેસ્લિપ ડાઉનલોડ',
  payslipTitle: 'માસિક પેસ્લિપ',
  payslipEarnings: 'કમાણી',
  payslipDeductions: 'કપાત',
  payslipDaysWorked: 'કામના દિવસો',
  payslipGeneratedBy: 'Development Express દ્વારા બનાવેલ',
  operatorPayrollTitle: 'મારો પગાર',
  payrollMonthlySalary: 'માસિક પગાર',
  payrollCurrentMonth: 'વર્તમાન મહિનો',
  payrollPreviousMonth: 'ગત મહિનો',
  ownerAttendanceTitle: 'હાજરી',
  ownerAttendanceEdit: 'સંપાદન',
  ownerAttendanceSave: 'સાચવો',
  ownerAttendanceNoRecords: 'આ મહિને માટે હાજરી રેકોર્ડ નથી',
  ownerAttendanceOverrideSuccess: 'હાજરી અપડેટ થઈ',
  ownerSalaryUpdated: 'પગાર સફળતાપૂર્વક અપડેટ થયો',
  ownerSalaryEditBtn: 'પગાર સંપાદન',
  ownerSalaryNotSet: 'પગાર સેટ નથી — પેયરોલ માટે પગાર સેટ કરો',
  duration: "અવધિ",
  durationLabel: 'અવધિ',
  plQuotaLabel: 'PL કોટા',
  plUsed: 'વપરાયેલ',
  plAllowed: 'મંજૂર',
  plRemaining: 'બાકી',
  plQuotaUpdated: 'PL કોટા અપડેટ',
  plQuotaExhausted: 'PL કોટા પૂરો — વેતન વગરની રજા તરીકે નોંધાયો',
  plRemainingLabel: 'બાકી PL',
  noAttendanceRecords: 'હજી સુધી હાજરી નોંધ નથી',
  noFuelLogs: 'હજી સુધી ઇંધણ લોગ નથી',
  noIssuesYet: 'હજી સુધી કોઈ સમસ્યા નોંધાઈ નથી',
  failedToLoad: 'ડેટા લોડ કરવામાં અસફળ',
  failedToLoadReport: 'રિપોર્ટ લોડ કરવામાં અસફળ',
  failedToLoadIssues: 'સમસ્યાઓ લોડ કરવામાં અસફળ',
  failedToLoadAlerts: 'અલર્ટ લોડ કરવામાં અસફળ',
  noRecordsMonth: 'આ મહિનામાં નોંધ નથી',
  underReview: 'સમીક્ષા હેઠળ',
  issueResolved: 'ઉકેલાયેલ',
  presentDaysLabel: 'હાજર દિવસો',
  halfDaysLabel: 'અર્ધા દિવસો',
  absentDaysLabel: 'ગેરહાજર દિવસો',
  totalHmrLabel: 'કુલ HMR',
  noActiveBookingIdle: 'કોઈ સક્રિય બુકિંગ નથી — મશીન નિષ્ક્રિય',
  siteLocationNotCaptured: 'સાઇટ સ્થાન નોંધાયું નથી',
  siteLocationNotAvailable: 'સાઇટ સ્થાન ઉપલબ્ધ નથી',
  bookingRefLabel: 'બુકિંગ Ref',
  alertPendingBookings: 'બાકી બુકિંગ',
  alertPendingPayouts: 'બાકી ચુકવણી',
  alertLowFuel: 'ઓછું ઇંધણ',
  alertOpenIssues: 'ખુલ્લી સમસ્યાઓ',
  noMachineRunning: 'હાલમાં કોઈ મશીન ચાલુ નથી',
  trackingEmptyHint: 'મશીન મોકલાયા પછી તમારી સક્રિય બુકિંગ અહીં દેખાશે.',
  trackingUpdatedEvery5s: 'દર ૫ સેકંડે અપડેટ',
  fuelLastOperatorUpdate: '(ઓપરેટરનું છેલ્લું અપડેટ)',
  alertExtensionPending: 'બુકિંગ એક્સ્ટેન્શન બાકી',
  alertConfirmCompletion: 'કૃપા કરીને કામ પૂર્ણતાની પુષ્ટિ કરો',
  alertWalletCredited: 'વૉલેટમાં ઉમેર્યું',
  alertFeedbackRequest: 'કામ પૂર્ણ — તમારો અભિપ્રાય શેર કરો',
  noLogsYet: 'હજી સુધી કોઈ પ્રવૃત્તિ નોંધાઈ નથી',
  todayActivityLog: 'આજની પ્રવૃત્તિ લોગ',
  machineLogSubtitle: 'ઇંધન, હાજરી, સમસ્યાઓ — સ્થાનિક સત્ર લોગ',
  timerPaused: 'Timer અટકાવ્યો',
  liveBookingTitle: 'લાઇવ બુકિંગ',
  machineLogTimerHint: 'Timer Admin શરૂ કરે છે. નીચે તમારો વાસ્તવિક કામનો સમય દર્જ કરો — પૂર્ણ થયે Mark Work Complete પર ક્લિક કરો.',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'હાજરી',
  ownerAlertBookingPending: 'નવી બુકિંગ તમારી મંજૂરી માટે બાકી —',
  ownerAlertBookingHours: 'કલાક',
  ownerAlertPayoutPending: '₹{{amount}} ની ચુકવણી ટ્રાન્સફર માટે બાકી',
  ownerAlertFuelLow: 'ઇંધન ઓછું',
  ownerAlertFuelRemaining: 'બાકી',
  ownerAlertIssue: 'સમસ્યા નોંધાઈ',
  iotGpsDevicesActive: 'GPS ઉપકરણો સક્રિય',
  iotDashcamsOnline: 'ડેશકેમ ઑનલાઇન',
  iotFuelSensorsActive: 'ઇંધન સેન્સર સક્રિય',
  iotMachinesLocked: 'મશીનો લૉક',
  iotDeviceStatus: 'IoT ઉપકરણ સ્થિતિ',
  iotColMachine: 'મશીન',
  iotColGps: 'GPS',
  iotColLocation: 'સ્થાન',
  iotColFuel: 'ઇંધન %',
  iotColDashcam: 'ડેશકેમ',
  iotColIgnition: 'ઇગ્નિશન',
  iotColAction: 'ક્રિયા',
  iotStatusOnline: 'ઑનલાઇન',
  iotStatusNotConnected: 'કનેક્ટ નથી',
  iotStatusLive: 'લાઇવ',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'લૉક',
  iotNotConnectedBanner: 'IoT હાર્ડવેર હજી સ્થાપિત નથી. Teltonika ઉપકરણ સ્થાપન પછી GPS, ડેશકેમ અને રિમોટ લૉક સુવિધાઓ ઉપલબ્ધ થશે.',
  fuelUpdateTitle: 'ઇંધન અપડેટ',
  fuelSensorAccuracyNote: 'ઓપરેટર દ્વારા ઇંધન સ્તર નોંધાયું · મેન્યુઅલ એન્ટ્રી',
  bookingsTab: 'બુકિંગ',
  unknownLabel: 'અજાણ્યું',
  naLabel: 'N/A',
  baseLabel: 'આધાર',
  qtyLabel: 'જથ્થો',
  actualHrsLabel: 'વાસ્તવિક કલાક',
  auditStatTotal: 'કુલ',
  auditStatSecurity: 'સુરક્ષા',
  auditStatActors: 'કર્તાઓ',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'બિન-Admin',
  kycDocLicense: 'લાઇસેન્સ',
  kycDocAadhaarFront: 'Aadhaar સામે',
  kycDocAadhaarBack: 'Aadhaar પાછળ',
  kycDocPoliceVerification: 'પોલીસ ચકાસણી',
  kycVerification: 'KYC ચકાસણી',
  kycNotSubmitted: 'KYC સબમિટ નથી',
  kycUnderReview: 'KYC review માં છે',
  kycVerified: 'KYC ચકાસાયેલ',
  kycRejected: 'KYC નકારાયેલ',
  kycAadhaarFront: 'Aadhaar સામે',
  kycAadhaarBack: 'Aadhaar પાછળ',
  kycSelfie: 'સેલ્ફી',
  kycSubmitBtn: 'KYC દસ્તાવેજો સબમિટ કરો',
  kycSubmitSuccess: 'દસ્તાવેજો સબમિટ — review માં',
  kycResubmit: 'દસ્તાવેજો ફરી સબમિટ કરો',
  adminKycTitle: 'ક્લાયન્ટ KYC સમીક્ષા',
  adminKycAllFilter: 'બધા',
  adminKycNoSubmissions: 'હજુ સુધી KYC સબમિશન નથી',
  adminOwnerKycTitle: 'માલિક KYC સમીક્ષા',
  adminOwnerKycNoSubmissions: 'હજુ સુધી કોઈ માલિક KYC સબમિશન નથી',
  adminOperatorKycTitle: 'ઓપરેટર KYC સમીક્ષા',
  adminOperatorKycNoSubmissions: 'હજુ સુધી કોઈ ઓપરેટર KYC સબમિશન નથી',
  kycRejectedWarning: 'તમારું KYC નકારવામાં આવ્યું. કૃપા કરીને દસ્તાવેજો ફરી સબમિટ કરો.',
  kycNotSubmittedHint: 'વિશ્વસનીય અનુભવ માટે KYC પૂર્ણ કરો.',
  kycPendingHint: 'તમારું KYC સમીક્ષા હેઠળ છે.',
  kycGoToTab: 'KYC પર જાઓ',
  adminKycApproveBtn: 'મંજૂર',
  adminKycRejectBtn: 'નકાર',
  adminKycViewDocs: 'દસ્તાવેજો જુઓ',
  adminKycRejectReason: 'નકારણું કારણ',
  adminKycRereviewBtn: 'ફરી સમીક્ષા',
  kycPan: 'PAN કાર્ડ',
  kycOwnerSubmitSuccess: 'દસ્તાવેજો સબમિટ — તમારું KYC સમીક્ષા હેઠળ',
  kycLicense: 'ડ્રાઇવિંગ લાઇસન્સ',
  kycPoliceVerification: 'પોલીસ ચકાસણી',
  kycOperatorSubmitSuccess: 'દસ્તાવેજો સબમિટ — તમારું KYC સમીક્ષા હેઠળ',
  operatorKycRejectedAssign: 'આ ઓપરેટરનું KYC નકારાયું — ફરી મંજૂર થાય ત્યાં સુધી તેમને સોંપી શકાતા નથી.',
  operatorsColOperator: 'ઓપરેટર',
  operatorsColEmail: 'ઈમેઇલ',
  operatorsColPhone: 'ફોન',
  operatorsColDocuments: 'દસ્તાવેજો',
  operatorsColStatus: 'સ્થિતિ',
  operatorsDocumentsBtn: 'દસ્તાવેજો ({{count}})',
  operatorsNoResults: 'કોઈ ઓપરેટર મળ્યા નહીં',
  operatorsAllTitle: 'બધા ઓપરેટર ({{count}})',
  operatorsKycDialogDesc: 'KYC દસ્તાવેજો',
  bookingsCountLabel: '{{count}} બુકિંગ',
  complianceDates: 'અનુપાલન તારીખો',
  complianceInsurance: 'વીમો',
  complianceRcBook: 'RC બુક',
  compliancePuc: 'PUC',
  complianceNotSet: 'સેટ નથી',
  complianceExpired: 'સમાપ્ત',
  complianceExpiringSoon: 'ટૂંક સમયમાં સમાપ્ત',
  complianceExpiringCritical: '7 દિવસમાં સમાપ્ત',
  complianceValid: 'માન્ય',
  complianceUpdateBtn: 'અનુપાલન તારીખો અપડેટ કરો',
  complianceSaveBtn: 'સાચવો',
  complianceAlertsTitle: 'અનુપાલન અલર્ટ',
  complianceAllCompliant: 'બધી મશીનો અનુપાલનમાં ✅',
  complianceColMachine: 'મશીન',
  complianceColOwner: 'માલિક',
  complianceColInsurance: 'વીમો',
  complianceColRcBook: 'RC બુક',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'શરૂઆતની તારીખ',
  complianceEndDate: 'સમાપ્તિ તારીખ',
  complianceExtractBtn: 'તારીખો આપમેળે ભરવા દસ્તાવેજ અપલોડ કરો',
  complianceExtractSuccess: 'તારીખો કાઢવામાં આવી — સાચવતા પહેલાં ચકાસો',
  complianceExtractError: 'તારીખો કાઢી શકાઈ નહીં — કૃપા કરીને મેન્યુઅલી દાખલ કરો',
  complianceExtracting: 'દસ્તાવેજ વાંચી રહ્યા છીએ...',
  serviceHistory: 'સેવા ઇતિહાસ',
  serviceLastService: 'છેલ્લી સેવા',
  serviceNoRecords: 'હજી સેવા રેકોર્ડ નથી',
  serviceNextDue: 'આગામી સેવા બાકી',
  serviceNextHmr: 'આગામી સેવા પર',
  serviceAddLog: 'સેવા લોગ ઉમેરો',
  serviceDate: 'સેવા તારીખ',
  serviceType: 'સેવા પ્રકાર',
  serviceHmr: 'સેવા HMR',
  serviceNextDate: 'આગામી સેવા તારીખ',
  serviceWorkDone: 'કરેલું કામ',
  serviceNotes: 'નોંધ',
  serviceTypeRoutine: 'નિયમિત',
  serviceTypeMajor: 'મુખ્ય',
  serviceTypeBreakdown: 'બિગડ',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'અન્ય',
  serviceOverdue: 'મુદત વીતી',
  serviceDueSoon: 'જલ્દી બાકી',
  fleetAnalytics: 'ફ્લીટ વિશ્લેષણ',
  analyticsRevenue: 'કુલ આવક',
  analyticsBookings: 'કુલ બુકિંગ',
  analyticsHours: 'કુલ કલાક',
  analyticsActiveMachines: 'સક્રિય મશીન',
  analyticsMonthlyTrend: 'માસિક આવક વલણ',
  analyticsMachineTable: 'મશીન પ્રમાણે આવક',
  analyticsNoData: 'આ અવધિમાં પૂર્ણ બુકિંગ નથી',
  analyticsLastBooking: 'છેલ્લી બુકિંગ',
  analytics3Months: '3 મહિના',
  analytics6Months: '6 મહિના',
  analytics12Months: '12 મહિના',
  adminAnalytics: 'વિશ્લેષણ',
  adminFleetTitle: 'ફ્લીટ વિશ્લેષણ',
  adminFleetPlatformRevenue: 'પ્લેટફોર્મ આવક',
  adminFleetActiveOwners: 'સક્રિય માલિકો',
  adminFleetOwnerCol: 'માલિક',
  adminFleetMonthlyTrend: 'માસિક આવક ટ્રેન્ડ',
  adminFleetMachineTable: 'મશીન દ્વારા આવક',
  adminFleetNoData: 'આ અવધિમાં પૂર્ણ બુકિંગ નથી',
  adminFinancialIntelligence: 'મશીન નાણાકીય બુદ્ધિ',
  adminTotalInvested: 'કુલ રોકાણ',
  adminTotalEarned: 'કુલ કમાણી',
  adminAvgRecovery: 'સરેરાશ રિકવરી',
  adminBreakEvenRate: 'બ્રેક-ઈવન દર',
  adminProfitMargin: 'નફો માર્જિન',
  adminNoFinancialData: 'હજુ સુધી નાણાકીય ડેટા સાથેની મશીન નથી',
  adminMachineDetail: 'મશીન વિગત',
  adminCallOwner: 'માલિકને કોલ કરો',
  adminWhatsappOwner: 'WhatsApp માલિક',
  adminMarketRates: 'માર્કેટ રેટ સબમિશન',
  adminMarketRateDelete: 'કાઢી નાખો',
  adminMarketRateDeleteConfirm: 'આ માર્કેટ રેટ સબમિશન કાઢી નાખવું?',
  adminMarketRateDeleted: 'માર્કેટ રેટ કાઢી નાખ્યું',
  adminMarketRateNoData: 'હજુ સુધી કોઈ માર્કેટ રેટ સબમિશન નથી',
  marketRateApprove: 'મંજૂર કરો',
  marketRateReject: 'નકારો',
  marketRateApproved: 'મંજૂર',
  marketRateRejected: 'નકારેલ',
  marketRatePending: 'બાકી',
  marketRateReviewed: 'માર્કેટ રેટની સમીક્ષા થઈ',
  marketRatePendingReview: 'તમારો રેટ સબમિટ થયો છે અને એડમિન સમીક્ષા માટે બાકી છે.',
  marketRateEditApprove: 'સુધારો અને મંજૂર કરો',
  marketRateEditMin: 'સુધારેલ ન્યૂનતમ રેટ (₹/કલાક)',
  marketRateEditMax: 'સુધારેલ મહત્તમ રેટ (₹/કલાક)',
  adminPayrollOverview: 'પગાર વિહંગાવલોકન',
  adminPayrollTotalOperators: 'કુલ ઓપરેટર્સ',
  adminPayrollTotalGross: 'કુલ દેવાય રકમ',
  adminPayrollTotalNet: 'કુલ નેટ દેવાય',
  adminPayrollNoData: 'આ મહિને માટે પગાર ડેટા નથી',
  subTabSchedule: 'શેડ્યૂલ',
  subTabHistory: 'ઇતિહાસ',
  subTabAnalytics: 'વિશ્લેષણ',
  clientAnalyticsTitle: 'બુકિંગ વિશ્લેષણ',
  clientAnalyticsSpend: 'કુલ ખર્ચ',
  clientAnalyticsHours: 'કુલ કલાક',
  clientAnalyticsBookings: 'પૂર્ણ બુકિંગ',
  clientAnalyticsMachines: 'વપરાયેલી મશીનો',
  clientAnalyticsAvgSpend: 'પ્રતિ બુકિંગ સરેરાશ',
  clientAnalyticsMonthlyTrend: 'માસિક ખર્ચ ટ્રેન્ડ',
  clientAnalyticsTopMachines: 'ટોચની મશીનો',
  clientAnalyticsNoData: 'આ અવધિમાં પૂર્ણ બુકિંગ નથી',
  operatorAnalyticsTitle: 'કામ વિશ્લેષણ',
  operatorAnalyticsPresentDays: 'હાજર દિવસો',
  operatorAnalyticsHalfDays: 'અર્ધ દિવસ',
  operatorAnalyticsHmr: 'કુલ HMR',
  operatorAnalyticsJobs: 'પૂર્ણ કામ',
  operatorAnalyticsIssues: 'રિપોર્ટ કરેલ સમસ્યાઓ',
  operatorAnalyticsAvgHmr: 'સરેરાશ HMR/દિવસ',
  operatorAnalyticsMonthlyTrend: 'માસિક કામ ટ્રેન્ડ',
  operatorAnalyticsIssueBreakdown: 'પ્રકાર મુજબ સમસ્યાઓ',
  operatorAnalyticsRecentJobs: 'તાજેતરના કામ',
  operatorAnalyticsNoData: 'આ અવધિમાં કામ રેકોર્ડ નથી',
  adminServiceAlertsTitle: 'સેવા અલર્ટ',
  adminServiceAllOk: 'બધી મશીનોના સેવા રેકોર્ડ અપ-ટુ-ડેટ છે ✅',
  adminServiceNoRecord: 'રેકોર્ડ નથી',
  adminServiceColLastService: 'છેલ્લી સેવા',
  adminServiceColNextDue: 'આગામી દેવું',
  adminServiceColServiceStatus: 'સેવા સ્થિતિ',
  adminMachinesColMinHrs: 'ન્યૂનતમ કલાક',
  adminMachinesColRateDay: 'દર/દિવસ',
  adminClientName: 'ગ્રાહકનું નામ',
  adminOwnerName: 'માલિકનું નામ',
  adminPayoutWallet: 'પેઆઉટ વૉલેટ',
  adminFooterMachines: 'મશીનો',
  adminFooterClients: 'ગ્રાહકો',
  adminFooterOwners: 'માલિકો',
  auditSeverityCritical: 'ગંભીર',
  auditSeverityHigh: 'ઉચ્ચ',
  auditSeverityMedium: 'મધ્યમ',
  auditSeverityNormal: 'સામાન્ય',
  auditCopyEvent: 'ઇવેન્ટ કૉપી કરો',
  auditViewDetails: 'વિગતો જુઓ',
  auditHideDetails: 'વિગતો છુપાવો',
  auditCopyJson: 'JSON કૉપી કરો',
  auditNoLogs: 'કોઈ ઑડિટ લૉગ નથી',
  auditIntroBanner: 'લૉગિન, એડમિન ક્રિયાઓ અને સુરક્ષા ઘટનાઓ. ફિલ્ટર લોડ કરેલ પરિણામો પર લાગુ પડે છે; જૂની પંક્તિઓ માટે વધુ લોડ કરો.',
  auditLoaded: 'લોડ કરેલ',
  auditMoreAvailable: 'વધુ ઉપલબ્ધ',
  auditEndOfList: 'યાદી સમાપ્ત',
  auditFilterActive: 'ફિલ્ટર સક્રિય',
  auditFiltersActive: 'ફિલ્ટર સક્રિય',
  auditSeverityBreakdown: 'ગંભીરતા વિભાજન (વર્તમાન યાદી)',
  auditPressSlash: 'ક્રિયા ફિલ્ટર પર ફોકસ કરવા / દબાવો',
  auditFilters: 'ફિલ્ટર',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'બધી ભૂમિકાઓ',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'મેટાડેટા JSON શોધો',
  auditFilterFromPlaceholder: 'શરૂઆત તારીખ અને સમય',
  auditFilterToPlaceholder: 'અંત તારીખ અને સમય',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'સમય ક્ષેત્ર:',
  auditTimezoneSuffix: '(સ્થાનિક)',
  auditHideCsvOptions: 'CSV કૉલમ વિકલ્પો છુપાવો',
  auditShowCsvOptions: 'CSV કૉલમ વિકલ્પો બતાવો',
  auditCsvColCreatedAt: 'નિર્માણ સમય',
  auditCsvColAction: 'ક્રિયા',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'મેટાડેટા',
  auditFooterLoaded: 'લોડ કરેલ',
  auditFooterLogs: 'ઓડિટ લૉગ',
  auditFooterMoreAvailable: '(વધુ ઉપલબ્ધ)',
  auditFooterAllLoaded: '(બધા લોડ કરેલ)',
  auditActor: 'એક્ટર',
  auditEntity: 'એન્ટિટી',
  auditEventLog: 'ઇવેન્ટ લૉગ',
  notificationCenter: 'સૂચનાઓ',
  notifChannelAll: 'બધા',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ઈમેલ',
  notifChannelPush: 'પુશ',
  notifChannelSms: 'SMS',
  notifStatusSent: 'મોકલાયું',
  notifStatusFailed: 'નિષ્ફળ',
  notifStatusPending: 'બાકી',
  notifEmpty: 'હજી સૂચનાઓ નથી',
  notifLoadMore: 'વધુ લોડ કરો',
  adminNotifLog: 'સૂચના લોગ',
  adminNotifColUser: 'વપરાશકર્તા',
  adminNotifColRole: 'ભૂમિકા',
  adminNotifNoData: 'હજી સુધી કોઈ સૂચના લોગ નથી',
  etaOwnerApproval: 'માલિકની મંજૂરીની રાહ જોવાઈ રહી છે',
  etaWorkInProgress: 'અંદાજિત પૂર્ણતા',
  etaPaymentDeadline: 'ચુકવણી પુષ્ટિની અંતિમ તારીખ',
  etaWorkCompleted: 'કામ પૂર્ણ થયું',
  etaDisputeReview: 'DE ટીમ વિવાદની સમીક્ષા કરે છે',
  etaMinutesRemaining: '{n} મિનિટ બાકી',
  etaHoursRemaining: '{n} કલાક બાકી',
  txRecharge: 'વૉલેટ રિચાર્જ',
  txBookingAdvance: 'બુકિંગ એડવાન્સ',
  txBookingPayment: 'બુકિંગ ચુકવણી',
  txSettlement: 'સેટલમેન્ટ',
  txRefund: 'રિફંડ',
  txPenalty: 'દંડ',
  txCommission: 'કમિશન',
  tacTitle: "નિયમો અને શરતો",
  tacPrivacy: "ગોપનીયતા નીતિ",
  tacRefund: "રિફંડ નીતિ",
  tacCancellation: "રદીકરણ નીતિ",
  tacServiceDelivery: "સેવા વિતરણ નીતિ",
  tacIntro: "બુકિંગ પહેલાં અમારી નીતિઓ જુઓ",
  tacBannerTitle: "નિયમો અપડેટ ઉપલબ્ધ",
  tacBannerOpen: "નિયમો ખોલો",
  tacBannerAgree: "મેં વાંચી લીધું છે અને સંમત છું",
  tacBannerLater: "પછીથી",
  clientPoliciesTitle: "ક્લાયન્ટ નીતિઓ",
  machineGroupAvailable: "ઉપલબ્ધ",
  machineGroupBusy: "વ્યસ્ત",
  dewateringReferral: "ડીવોટરિંગ (પંપ) સેવા જોઈએ છે? MachineOS જલ્દી પંપ કોન્ટ્રાક્ટર સેવાઓ ઉમેરશે. રેફરલ માટે સપોર્ટનો સંપર્ક કરો.",
  noActiveWork: "આ મહિને કોઈ સક્રિય કામ નથી",
  accountTab: "એકાઉન્ટ",
  recentActivity: "તાજેતરની પ્રવૃત્તિ",
  goodMorning: "શુભ સવાર",
  goodAfternoon: "શુભ બપોર",
  goodEvening: "શુભ સાંજ",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
